import type { FaireProductEntity } from "../../entity_types/product";

export const p_5e8pynduyx: FaireProductEntity = {
  token: "p_5e8pynduyx",
  type: "product",
  name: "Kettle Potato Chips Variety Pack (24 count)",
  brandToken: "b_7czabpidt2",
  brandName: "Deep River Snacks",
  imageUrl:
    "https://cdn.faire.com/fastly/b3704f16115f28b9aa1ccaa98df6486025b21540c451ffe444c3c896f206c0c0.png",
  galleryImageUrls: [],
  priceDollars: 41.56,
  description:
    "Contains 24 - 2 Ounce Bags of Deep River Potato Chips Sea Salt, Salt & Cracked Pepper, Sweet Maui Onion, Zesty Jalapeno, Sea Salt & Vinegar, Mesquite BBQ\nPacked with all your favorite snacks, deep River variety packs have something crunchy and satisfying for everyone.\nNo artificial flavors, colors, or preservatives, Certified Gluten-free; Produced in a nut-free facility. Kosher certified.",
  tags: [],
  msrpDollars: 83.11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:37.061Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
